import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { Tooltip } from "../../Tooltip/index.js";
import { Box } from "../../Box/index.js";
import { useIsDesktop } from "../../hooks/index.js";
import Day_styles from "./Day.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const Day = (t0)=>{
    const $ = c(75);
    let className;
    let day;
    let disabled;
    let hidden;
    let onMouseLeave;
    let other;
    let renderDayFooter;
    let renderDayTooltip;
    let selected;
    let testHoliday;
    let testIsEnd;
    let testIsInRange;
    let testIsStart;
    let today;
    if ($[0] !== t0) {
        ({ day, today, disabled, hidden, selected, testIsInRange, testIsEnd, testIsStart, testHoliday, className, onMouseLeave, renderDayTooltip, renderDayFooter } = t0), other = _object_without_properties(t0, [
            "day",
            "today",
            "disabled",
            "hidden",
            "selected",
            "testIsInRange",
            "testIsEnd",
            "testIsStart",
            "testHoliday",
            "className",
            "onMouseLeave",
            "renderDayTooltip",
            "renderDayFooter"
        ]);
        $[0] = t0;
        $[1] = className;
        $[2] = day;
        $[3] = disabled;
        $[4] = hidden;
        $[5] = onMouseLeave;
        $[6] = other;
        $[7] = renderDayFooter;
        $[8] = renderDayTooltip;
        $[9] = selected;
        $[10] = testHoliday;
        $[11] = testIsEnd;
        $[12] = testIsInRange;
        $[13] = testIsStart;
        $[14] = today;
    } else {
        className = $[1];
        day = $[2];
        disabled = $[3];
        hidden = $[4];
        onMouseLeave = $[5];
        other = $[6];
        renderDayFooter = $[7];
        renderDayTooltip = $[8];
        selected = $[9];
        testHoliday = $[10];
        testIsEnd = $[11];
        testIsInRange = $[12];
        testIsStart = $[13];
        today = $[14];
    }
    const isDesktop = useIsDesktop();
    const { classes } = Day_styles();
    let t1;
    if ($[15] !== day || $[16] !== renderDayTooltip) {
        t1 = null == renderDayTooltip ? void 0 : renderDayTooltip(day);
        $[15] = day;
        $[16] = renderDayTooltip;
        $[17] = t1;
    } else t1 = $[17];
    const tooltipContent = t1;
    let t2;
    if ($[18] !== day || $[19] !== testIsInRange) {
        t2 = null == testIsInRange ? void 0 : testIsInRange(day);
        $[18] = day;
        $[19] = testIsInRange;
        $[20] = t2;
    } else t2 = $[20];
    const isInRange = t2;
    let t3;
    if ($[21] !== day || $[22] !== isInRange || $[23] !== testIsStart) {
        t3 = isInRange && (null == testIsStart ? void 0 : testIsStart(day));
        $[21] = day;
        $[22] = isInRange;
        $[23] = testIsStart;
        $[24] = t3;
    } else t3 = $[24];
    const isStart = t3;
    let t4;
    if ($[25] !== day || $[26] !== isInRange || $[27] !== testIsEnd) {
        t4 = isInRange && (null == testIsEnd ? void 0 : testIsEnd(day));
        $[25] = day;
        $[26] = isInRange;
        $[27] = testIsEnd;
        $[28] = t4;
    } else t4 = $[28];
    const isEnd = t4;
    const { outsideCurrentMonth } = other;
    const t5 = tooltipContent || "";
    const t6 = !isDesktop || !tooltipContent || outsideCurrentMonth;
    const t7 = isInRange && classes.dayWrapperInRange;
    const t8 = isStart && classes.dayWrapperStart;
    const t9 = isEnd && classes.dayWrapperEnd;
    let t10;
    if ($[29] !== classes.dayWrapper || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
        t10 = classnames(classes.dayWrapper, t7, t8, t9);
        $[29] = classes.dayWrapper;
        $[30] = t7;
        $[31] = t8;
        $[32] = t9;
        $[33] = t10;
    } else t10 = $[33];
    let t11;
    if ($[34] !== classes.current || $[35] !== classes.day || $[36] !== classes.dayDisabled || $[37] !== classes.daySelected) {
        t11 = {
            root: classes.day,
            today: classes.current,
            selected: classes.daySelected,
            disabled: classes.dayDisabled
        };
        $[34] = classes.current;
        $[35] = classes.day;
        $[36] = classes.dayDisabled;
        $[37] = classes.daySelected;
        $[38] = t11;
    } else t11 = $[38];
    let t12;
    if ($[39] !== className || $[40] !== classes.hidden || $[41] !== classes.holiday || $[42] !== day || $[43] !== hidden || $[44] !== testHoliday) {
        t12 = classnames(className, {
            [classes.hidden]: hidden,
            [classes.holiday]: null == testHoliday ? void 0 : testHoliday(day),
            aqa_icon_button: true
        });
        $[39] = className;
        $[40] = classes.hidden;
        $[41] = classes.holiday;
        $[42] = day;
        $[43] = hidden;
        $[44] = testHoliday;
        $[45] = t12;
    } else t12 = $[45];
    const t13 = hidden || disabled ? -1 : 0;
    let t14;
    if ($[46] !== day || $[47] !== onMouseLeave) {
        t14 = (e)=>null == onMouseLeave ? void 0 : onMouseLeave(e, day);
        $[46] = day;
        $[47] = onMouseLeave;
        $[48] = t14;
    } else t14 = $[48];
    let t15;
    if ($[49] !== day || $[50] !== disabled || $[51] !== hidden || $[52] !== other || $[53] !== selected || $[54] !== t11 || $[55] !== t12 || $[56] !== t13 || $[57] !== t14 || $[58] !== today) {
        t15 = /*#__PURE__*/ jsx(PickersDay, _object_spread({
            classes: t11,
            className: t12,
            day: day,
            today: today,
            selected: selected,
            disabled: disabled,
            hidden: hidden,
            tabIndex: t13,
            disableRipple: true,
            onMouseLeave: t14
        }, other));
        $[49] = day;
        $[50] = disabled;
        $[51] = hidden;
        $[52] = other;
        $[53] = selected;
        $[54] = t11;
        $[55] = t12;
        $[56] = t13;
        $[57] = t14;
        $[58] = today;
        $[59] = t15;
    } else t15 = $[59];
    let t16;
    if ($[60] !== day || $[61] !== isInRange || $[62] !== outsideCurrentMonth || $[63] !== renderDayFooter) {
        t16 = !outsideCurrentMonth && (null == renderDayFooter ? void 0 : renderDayFooter(day, !!isInRange));
        $[60] = day;
        $[61] = isInRange;
        $[62] = outsideCurrentMonth;
        $[63] = renderDayFooter;
        $[64] = t16;
    } else t16 = $[64];
    let t17;
    if ($[65] !== t15 || $[66] !== t16) {
        t17 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            flexDirection: "column",
            position: "relative",
            children: [
                t15,
                t16
            ]
        });
        $[65] = t15;
        $[66] = t16;
        $[67] = t17;
    } else t17 = $[67];
    let t18;
    if ($[68] !== t10 || $[69] !== t17) {
        t18 = /*#__PURE__*/ jsx("div", {
            className: t10,
            children: t17
        });
        $[68] = t10;
        $[69] = t17;
        $[70] = t18;
    } else t18 = $[70];
    let t19;
    if ($[71] !== t18 || $[72] !== t5 || $[73] !== t6) {
        t19 = /*#__PURE__*/ jsx(Tooltip, {
            title: t5,
            placement: "bottom",
            disabled: t6,
            children: t18
        });
        $[71] = t18;
        $[72] = t5;
        $[73] = t6;
        $[74] = t19;
    } else t19 = $[74];
    return t19;
};
export { Day };
